import * as React from "react";

import { ProfileContext } from "..";

export function useProfile() {
	const context = React.use(ProfileContext);
	if (!context) {
		throw new Error("useProfile must be used within an ProfileProvider");
	}
	return context;
}
